import { CircleSlash, TriangleAlert } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@/lib/utils/cn";

export function StatusLine({ tone, children }: { tone: "warning" | "error"; children: ReactNode }) {
  const Icon = tone === "warning" ? TriangleAlert : CircleSlash;
  return (
    <p
      data-testid="captain-tile-status"
      className={cn(
        "flex items-center gap-1.5 text-sm font-medium tabular-nums",
        tone === "warning" ? "[color:var(--badge-warning-text)]" : "[color:var(--badge-error-text)]",
      )}
    >
      <Icon className="size-4 shrink-0" aria-hidden />
      {children}
    </p>
  );
}
